import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "request",
    serviceName: "auth",
    query: gql`
      query request(
        $ids: [String]
        $type: String
        $statuses: [String]
        $request_date: String
        $do_date: String
        $code: String
        $for_role_ids: [String]
        $for_user_id: String
        $lab_id: String
        $for_lab_ids: [String]
        $unit_id: String
        $settlement_id: String
        $belongs_to_me: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
        $user_id: String
      ) {
        request(
          ids: $ids
          belongs_to_me: $belongs_to_me
          page: $page
          limit: $limit
        ) {
          total
          last_page
          data {
            id
            type
            info
            code
            status
            do_date
            details
            request_date
            user {
              id
              cellphone
              firstname
              lastname
            }
            for_user {
              id
              cellphone
              firstname
              lastname
            }
            for_role {
              id
              name
              title
            }
            #lab {
            #  id
            #  title
            #}
            #for_lab_ids {
            #  id
            #  title
            #}
            #unit {
            #  id
            #  title
            #}
            role {
              id
              name
              title
            }
            media {
              id
              full_url
            }
          }
        }
        task(
          ids: $ids
          type: $type
          statuses: $statuses
          request_date: $request_date
          do_date: $do_date
          code: $code
          for_role_ids: $for_role_ids
          for_user_id: $for_user_id
          lab_id: $lab_id
          for_lab_ids: $for_lab_ids
          unit_id: $unit_id
          settlement_id: $settlement_id
          belongs_to_me: $belongs_to_me
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
          user_id: $user_id
        ) {
          total
          last_page
          data {
            id
            type
            info
            code
            status
            do_date
            details
            request_date
            user {
              id
              cellphone
              firstname
              lastname
            }
            for_user {
              id
              cellphone
              firstname
              lastname
            }
            for_role {
              id
              name
              title
            }
            #lab {
            #  id
            #  title
            #}
            #for_lab_ids {
            #  id
            #  title
            #}
            unit {
              id
              title
            }
            role {
              id
              name
              title
            }
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
